import React from 'react'
import Breadcrumb from "./Breadcrumb";
import { Link } from 'react-router-dom';


import HeaderEight from "../components/header/HeaderEight";
// import FooterOne from "../components/footer/FooterOne";
import FooterSeven from "../components/footer/FooterSeven";

function OurService() {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Service Details' }
    ];
    return (
        <div className=''>

            <HeaderEight />
            <Breadcrumb title="Service Details" breadcrumbs={breadcrumbs} />

            {/* start service details area */}
            <div className="rts-service-details-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-md-12 col-sm-12 col-12">
                            {/* service details left area start */}
                            <div className="service-detials-step-1">
                                <div className="thumbnail">
                                    <img src="assets/images/service/01.jpg" alt="business-area" />
                                </div>
                                <h4 className="title">1 . Third-Party Inspection Services</h4>
                                {/* <p className="disc">
                                    Continually myocardinate holistic mindshare with client-based web
                                    services. Assertively e-enable catalysts for change before tested
                                    markets. Phosfluorescently maintain wireless scenarios after
                                    intermandated applications. Conveniently predominate revolutionary
                                    quality vectors through future-proof manufactured products.
                                    Enthusiastically transform distinctive collaboration.
                                </p>
                                <p className="disc">
                                    Intrinsicly coordinate multifunctional functionalities reliable
                                    potentialities. Objectively envisioneer high in convergence
                                    through collaborative networks. Interactively generate B2C
                                    e-tailers for business data restore fully researched relationships
                                    through resource maximizing results.
                                </p> */}
                                <ul className="space-y-3">
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}>  Cranes </span>- Mobile Crane ,Crawler Crane ,EOT Crane ,Jib Crane ,Gantry Crane ,Pedestal Crane ,Tower Crane ,Derrick Crane , Lorry Loader Crane ,Side Boom Pipe Layer.
                                    </li>
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}>  Lifting Equipment </span>-  Man Lift, Forklift, Wheel Loader, Backhoe Loader, Excavator, Shovel, Boom Loader, Scissor Lift, Road Roller, Bulldozer, Motor Grader, Tractor, Skip Loader, Skid Steer Loader.
                                    </li>
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}>  Vehicles & Transport </span>- Dump Truck, Water Tanker, Diesel Tanker, Telescopic Handler, MEWP (Mobile Elevating Work Platform), Light Vehicle (Zone 11), Heavy Vehicle (Zone 11).
                                    </li>
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}>  Compaction & Material Handling </span>- Plate/Roller Compactor, Monorail Beam, Containers (CCUs).
                                    </li>
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}>  Machines & Equipment </span>- Air Compressor, Diesel Tank (Lifting & MPI), Winch Loader, Welding Machine, Welding Generator, Power Generator.
                                    </li>
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}>  Loose Fitting Gears </span>- Shackles, Webbing Slings, Chain Slings, Wire Rope Sling.
                                    </li>
                                </ul>
                                <div className="row g-5 mt--30 mb--40">
                                <h4 className="title">2 . HSE SERVICES</h4>
                                    <div className="col-lg-6">
                                        {/* single service details card */}
                                        <div className="service-details-card">
                                            <div className="thumbnail">
                                                <img
                                                     src="assets/images/service/icon/12.svg"
                                                    alt=""
                                                    className="icon"
                                                />
                                            </div>
                                            <div className="details">
                                                <h6 className="title">HSE Procedures & Policies</h6>
                                                <p className="disc">
                                                Development and implementation of HSE management systems.
                                                </p>
                                            </div>
                                        </div>
                                        {/* single service details card End */}
                                    </div>
                                    <div className="col-lg-6">
                                        {/* single service details card */}
                                        <div className="service-details-card">
                                            <div className="thumbnail">
                                                <img
                                                     src="assets/images/service/icon/10.svg"
                                                    alt=""
                                                    className="icon"
                                                />
                                            </div>
                                            <div className="details">
                                                <h6 className="title">EHSE Training & Risk Management</h6>
                                                <p className="disc">
                                                Includes HAZID, HAZOP, and risk assessments.
                                                </p>
                                            </div>
                                        </div>
                                        {/* single service details card End */}
                                    </div>
                                    <div className="col-lg-6">
                                        {/* single service details card */}
                                        <div className="service-details-card">
                                            <div className="thumbnail">
                                                <img
                                                     src="assets/images/service/icon/11.svg"
                                                    alt=""
                                                    className="icon"
                                                />
                                            </div>
                                            <div className="details">
                                                <h6 className="title">Risk Assessments</h6>
                                                <p className="disc">
                                                Conducting quantitative and qualitative risk assessments (QRA).
                                                </p>
                                            </div> 
                                        </div>
                                        {/* single service details card End */}
                                    </div>
                                    <div className="col-lg-6">
                                        {/* single service details card */}
                                        <div className="service-details-card">
                                            <div className="thumbnail">
                                                <img
                                                     src="assets/images/service/icon/12.svg"
                                                    alt=""
                                                    className="icon"
                                                />
                                            </div>
                                            <div className="details">
                                                <h6 className="title">HSE Inspections & Audits</h6>
                                                <p className="disc">
                                                Comprehensive evaluations for safety compliance.
                                                </p>
                                            </div>
                                        </div>
                                        {/* single service details card End */}
                                    </div>
                                    <div className="col-lg-6">
                                        {/* single service details card */}
                                        <div className="service-details-card">
                                            <div className="thumbnail">
                                                <img
                                                     src="assets/images/service/icon/12.svg"
                                                    alt=""
                                                    className="icon"
                                                />
                                            </div>
                                            <div className="details">
                                                <h6 className="title">Occupational Health Services </h6>
                                                <p className="disc">
                                                Assessments and professional advice.
                                                </p>
                                            </div>
                                        </div>
                                        {/* single service details card End */}
                                    </div>
                                    <div className="col-lg-6">
                                        {/* single service details card */}
                                        <div className="service-details-card">
                                            <div className="thumbnail">
                                                <img
                                                    src="assets/images/service/icon/10.svg"
                                                    alt=""
                                                    className="icon"
                                                />
                                            </div>
                                            <div className="details">
                                                <h6 className="title">Food Hygiene Audits</h6>
                                                <p className="disc">
                                                Inspections to ensure food safety standards.
                                                </p>
                                            </div>
                                        </div>
                                        {/* single service details card End */}
                                    </div>
                                    <div className="col-lg-6">
                                        {/* single service details card */}
                                        <div className="service-details-card">
                                            <div className="thumbnail">
                                                <img
                                                    src="assets/images/service/icon/11.svg"
                                                    alt=""
                                                    className="icon"
                                                />
                                            </div>
                                            <div className="details">
                                                <h6 className="title">Incident Reporting</h6>
                                                <p className="disc">
                                                Independent accident and incident inspections and reporting.
                                                </p>
                                            </div>
                                        </div>
                                        {/* single service details card End */}
                                    </div>
                                    <div className="col-lg-6">
                                        {/* single service details card */}
                                        <div className="service-details-card">
                                            <div className="thumbnail">
                                                <img
                                                    src="assets/images/service/icon/12.svg"
                                                    alt=""
                                                    className="icon"
                                                />
                                            </div>
                                            <div className="details">
                                                <h6 className="title">Behavioral Safety Audits</h6>
                                                <p className="disc">
                                                Assessing and improving workplace safety behaviors.
                                                </p>
                                            </div>
                                        </div>
                                        {/* single service details card End */}
                                    </div>
                                </div>
                                {/* <p className="disc">
                                    Phosfluorescently maintain wireless scenarios after intermandated
                                    applications. Conveniently unique predominate revolutionary
                                    quality vectors through future-proof manufactured products.
                                    Objectively envisioneer high solution convergence through
                                    collaborative networks. Interactively generate B2C e-tailers for
                                    business data restore fully researched relationships through
                                    resource maximizing results.
                                </p> */}
                            </div>
                            <div className="service-detials-step-2 mt--40">
                                <h4 className="title">3 . Calibration Testing & Certification Services</h4>
                                <p className="disc mb--25">
                                We provide precise calibration and certification across pressure, temperature, electrical, linear, and torque disciplines, along with valve repair and testing. Our services ensure accurate performance and compliance with industry standards for all types of equipment.
                                </p>
                                {/* <p className="disc">
                                    Phosfluorescently maintain wireless scenarios after intermandated
                                    applications. Conveniently predominate misslat revolutionary
                                    quality vectors through future-proof manufactured products.
                                </p> */}
                                {/* stem-area start */}
                                {/* <div className="row  mb--40 g-5 mb_md--20 mb_sm--20">
                                    <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                                        <div className="single-service-step text-center">
                                            <p className="step">01</p>
                                            <h6 className="title">Pressure, Temperature, Electrical, and Torque Calibration</h6>
                                            <p className="disc">
                                                Tactical services through market web services
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                                        <div className="single-service-step text-center">
                                            <p className="step">02</p>
                                            <h6 className="title">STEP TWO</h6>
                                            <p className="disc">
                                                Tactical services through market web services
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                                        <div className="single-service-step text-center">
                                            <p className="step">03</p>
                                            <h6 className="title">STEP THREE</h6>
                                            <p className="disc">
                                                Tactical services through market web services
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <p className="disc">
                                    Conveniently predominate revolutionary quality vectors through
                                    future-proof manufactured products. Objectively envisioneer high
                                    in convergence through collaborative networks. Interactively
                                    generate B2C tailers for business data restore fully researched
                                    relationships through
                                </p> */}
                                <ul className="space-y-3">
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}> Pressure Calibration</span> - Sophisticated measurement discipline .
                                    </li>
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}> Temperature Calibration </span> - Real-time measurement discipline .
                                    </li>
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}> Electrical Calibration </span> - Multi-function measurement discipline .
                                    </li>
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}> Linear Calibration </span> - Precision measurement discipline .
                                    </li>
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}> Torque Calibration </span> - Rotational force measurement discipline .
                                    </li>
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}> Valve Repair, Test & Certification </span> - Comprehensive valve services .
                                    </li>
                                    <li className="flex items-center gap-2 text-lg">
                                        <i className="far fa-check-circle" style={{color:'blue'}} />
                                        <span style={{fontWeight:'bold',color:'#000'}}> Other Instruments Calibration </span>
                                    </li>
                                </ul>
                                {/* stem-area End */}
                            </div>
                            {/* service details left area end */}
                            <div className="service-detials-step-3 mt--70 mt_md--50">
                                <div className="row g-5 align-items-center">
                                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div className="thumbnail sm-thumb-service">
                                            <img src="assets/images/service/sm-01.jpg" alt="Service" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 mb_md--20 mb_sm--20">
                                       
                                        <p className="disc">
                                        All services are designed to help your business achieve its goals safely and efficiently by improving operations, ensuring compliance, reducing risks, and focusing on safety and quality .<br /><br /> Our approach is tailored to optimize productivity, minimize downtime, and ensure your business runs smoothly while meeting the highest standards of excellence.
                                        </p>
                                        {/* <div className="single-banifits">
                                            <i className="far fa-check-circle" style={{color:'blue'}} />
                                            <span>Pressure, Temperature, Electrical, and Torque Calibration</span>
                                        </div>
                                        <div className="single-banifits">
                                            <i className="far fa-check-circle" style={{color:'blue'}}  />
                                            <span>Valve Repair, Testing & Certification</span>
                                        </div>
                                        <div className="single-banifits">
                                            <i className="far fa-check-circle" style={{color:'blue'}}  />
                                            <span>Equipment Performance Audits</span>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*rts blog wizered area */}
                        <div className="col-xl-4 col-md-12 col-sm-12 col-12 mt_lg--60 pl--50 pl_md--0 pl-lg-controler pl_sm--0">
                            {/* single wizered start */}
                            <div className="rts-single-wized Categories service">
                                <div className="wized-header">
                                    <h5 className="title">Services</h5>
                                </div>
                                <div className="wized-body">
                                    {/* single categoris */}
                                    <ul className="single-categories">
                                        <li>
                                            <Link to={'#'}>
                                            Third-Party Inspection Services <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                    {/* single categoris End */}
                                    {/* single categoris */}
                                    <ul className="single-categories">
                                        <li>
                                            <Link to={'#'}>
                                                HSE SERVICES<i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                    {/* single categoris End */}
                                    {/* single categoris */}
                                    {/* <ul className="single-categories">
                                        <li>
                                            <Link to={'#'}>
                                                ISO Certification & Business Consultation <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul> */}
                                    {/* single categoris End */}
                                    {/* single categoris */}
                                    <ul className="single-categories">
                                        <li>
                                            <Link to={'#'}>
                                                Calibration Testing & Certification <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                    {/* single categoris End */}
                                    {/* single categoris */}

                                    {/* <ul className="single-categories">
                                        <li>
                                            <Link to={'#'}>
                                                Tax Managment <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul> */}

                                    {/* single categoris End */}
                                </div>
                            </div>
                            {/* single wizered End */}
                            {/* single wizered start */}
                            <div className="rts-single-wized download service">
                                <div className="wized-header">
                                    <h5 className="title">Download</h5>
                                </div>
                                <div className="wized-body">
                                    {/* single downlaod area start */}
                                    <div className="single-download-area">
                                        <img
                                            src="assets/images/service/icon/07.svg"
                                            alt="Business_downlaod"
                                        />
                                        <div className="mid">
                                            <h6 className="title">Our Brochures</h6>
                                            <span>Downlaod</span>
                                        </div>
                                        <Link className=" rts-btn btn-primary" to={'#'}>
                                            <i className="fal fa-arrow-right" />
                                        </Link>
                                    </div>
                                    {/* single downlaod area End */}
                                    {/* single downlaod area start */}
                                    <div className="single-download-area">
                                        <img
                                            src="assets/images/service/icon/08.svg"
                                            alt="Business_downlaod"
                                        />
                                        <div className="mid">
                                            <h6 className="title">Company Details</h6>
                                            <span>Downlaod</span>
                                        </div>
                                        <Link className=" rts-btn btn-primary" to={'#'}>
                                            <i className="fal fa-arrow-right" />
                                        </Link>
                                    </div>
                                    {/* single downlaod area End */}
                                </div>
                            </div>
                            {/* single wizered End */}
                            {/* single wizered start */}
                            <div className="rts-single-wized contact service">
                                <div className="wized-header">
                                    <Link to={'#'} style={{ display: 'flex', justifyContent: 'center' }}>
                                        <img src="assets/images/logo/able.png" style={{ width: '60%' }} alt="Business_logo" />
                                    </Link>
                                </div>
                                <div className="wized-body">
                                    <h5 className="title">Need Help? We Are Here To Help You</h5>
                                    <Link className="rts-btn btn-primary" to={'#'}>
                                        Contact Us
                                    </Link>
                                </div>
                            </div>
                            {/* single wizered End */}
                        </div>
                        {/* rts- blog wizered end area */}
                    </div>
                </div>
            </div>
            {/* End service details area */}

            {/* <FooterOne /> */}
            <FooterSeven />


        </div>
    )
}

export default OurService